import React, { FC, useState } from 'react';
import styled, { css } from 'styled-components';
import theme from 'theme';

import CloseIcon from 'components/icons/collapse/CloseIcon';
import OpenIcon from 'components/icons/collapse/OpenIcon';

type Props = {
  isDesktop: boolean;
  question: string;
  answer: string;
};

const FAQItem: FC<Props> = ({ answer, question, isDesktop }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Container key={question}>
      <Header onClick={() => setIsOpen((prev) => !prev)}>
        <Title $isDesktop={isDesktop}>{question}</Title>
        {isOpen ? (
          <CloseIcon color={theme.colors.darkBlueV2} />
        ) : (
          <OpenIcon color={theme.colors.darkBlueV2} />
        )}
      </Header>
      {isOpen && <Answer $isDesktop={isDesktop}>{answer}</Answer>}
    </Container>
  );
};

const Container = styled.article`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};
  border-left: 4px solid ${({ theme }) => theme.colors.darkBlueV2};
  border-radius: 4px;
  padding: 0 20px 10px;
  box-shadow: 0 5px 20px 0 rgba(0 0 0 / 5%);
`;

const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-top: 30px;
  padding-bottom: 20px;
  cursor: pointer;

  & svg {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
  }
`;

const Title = styled.h3<{ $isDesktop: boolean }>`
  font-size: 16px;
  line-height: 23px;
  color: ${({ theme }) => theme.colors.darkBlueV2};

  ${({ $isDesktop }) =>
    $isDesktop &&
    css`
      font-size: 20px;
      line-height: 20px;
    `}
`;

const Answer = styled.p<{ $isDesktop: boolean }>`
  font-weight: 300;
  font-size: ${({ $isDesktop }) => ($isDesktop ? '16px' : '14px')};
  line-height: 24px;
  opacity: 0.8;
  white-space: pre-line;
  border-top: 1px solid rgba(65 78 113/ 25%);
  padding-top: 30px;
  padding-bottom: 20px;
  margin-top: 10px;
`;

export default FAQItem;
